import { render } from "./New_ConsolidationForm.vue?vue&type=template&id=1d134753&scoped=true"
import script from "./New_ConsolidationForm.vue?vue&type=script&lang=js"
export * from "./New_ConsolidationForm.vue?vue&type=script&lang=js"

import "./New_ConsolidationForm.vue?vue&type=style&index=0&id=1d134753&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d134753"]])

export default __exports__